export default {
    planModulesTitle: 'Módulos y atributos del plan',
    planModulesSubtitle: 'Activa los módulos incluidos en el plan y configura sus límites',
    moduleIncluded: 'Incluido',
    moduleNotIncluded: 'No incluido',
    attributesTitle: 'Atributos',
    noAttributesConfigured: 'Este módulo aún no tiene atributos configurados',
    saveAttribute: 'Guardar',
    attributeUpdated: 'Atributo actualizado correctamente',
    attributeError: 'Error al guardar el atributo',
    moduleEnabledMsg: 'Módulo incluido en el plan',
    moduleDisabledMsg: 'Módulo removido del plan',
    moduleError: 'Error al cambiar el módulo del plan',
    confirmDisableModule: '¿Quitar este módulo del plan? Se conservarán sus atributos configurados.',
    enableEditFirst: 'Habilita la edición para modificar los módulos del plan',
    errorLoadingModules: 'Error al cargar los módulos del plan',
    booleanIncluded: 'Incluido',
    booleanNotIncluded: 'No incluido',
    instantSaveNote: 'Los cambios en módulos y atributos se guardan al instante',
    plansTitle: 'Planes',
    planInformation: 'Información del plan',
    newPlan: 'Nuevo plan',
    editPlan: 'Editar plan',
    createPlan: 'Crear plan',
    saveChanges: 'Guardar cambios',
    active: 'Activo',
    planCodePlaceholder: 'ej. basic',
    billingPeriod: 'Período de facturación',
    selectBillingPeriod: 'Seleccionar período',
    name_es: 'Nombre (Español)',
    nameEsPlaceholder: 'Nombre en español',
    name_en: 'Nombre (Inglés)',
    nameEnPlaceholder: 'Nombre en inglés',
    description_es: 'Descripción (Español)',
    descriptionEsPlaceholder: 'Descripción en español',
    description_en: 'Descripción (Inglés)',
    descriptionEnPlaceholder: 'Descripción en inglés',
    price: 'Precio',
    pricePlaceholder: '0.00',
    currency: 'Moneda',
    selectCurrency: 'Seleccionar moneda',
    displayOrder: 'Orden de visualización',
    targetProfile: 'Perfil objetivo',
    targetProfilePlaceholder: 'ej. Pymes, Empresas medianas',
    assignedTenants: 'Tenants asignados',
    compareTitle: 'Comparar planes',
    compareSubtitle: 'Selecciona de 2 a 4 planes para compararlos lado a lado',
    selectPlansToCompare: 'Selecciona planes (2 a 4)',
    compareButton: 'Comparar',
    compareAction: 'Comparar planes',
    noComparison: 'Selecciona al menos 2 planes y presiona Comparar',
    compareMinPlans: 'Selecciona al menos 2 planes para comparar',
    compareLoadError: 'Error al comparar los planes',
    featureColumn: 'Característica',
    attention: '¡Atención!',
    loadingPlan: 'Cargando plan...',
    creatingPlan: 'Creando plan...',
    savingChanges: 'Guardando cambios...',
    planCreated: 'Plan creado exitosamente',
    planUpdated: 'Plan actualizado exitosamente',
    errorLoadingPlan: 'Error al cargar el plan',
    errorCreatingPlan: 'Error al crear el plan',
    errorUpdatingPlan: 'Error al actualizar el plan',
};
